
/**
 * menu.js
 * Author: Bow Vernon
 * This module contains menu structure, and some helper functions
 */

/**
 * 'structure' berisi array dari objek menu entry.
 * ditaro di file ini karena klo file pure json gk bisa dikomeng
 *
 * menu entry bisa berupa:
 * - 'section' : penanda (ada underlinenya)
 * - 'list' : list dari beberapa 'item'
 * - 'item' : menu item yg bisa diklik, bisa pny anak jg, bisa dikasih icon
 */
const structure = [
	/**
	 * test area bwt gw
	 */
	/* {
		"section": "Test Area"
	},
	{
		"list": [
			{
				"item": "Test Page",
				"icon": "T",
				"to": "/test"
			},
			{
				"item": "Home Page",
				"icon": "H",
				"to": "/"
			}
		]
	}, */

	/**
	 * menu dashboard
	 */
	{
		"section": "Dashboard",
		"role": "siroleg.bc.analis,siroleg.administrator,siroleg.pemda.polpp"
	},
	{
		/**
		 * baru berisi peta sebaran kasus
		 */
		"list": [
			{
				"item": "Statistik Temuan",
				// "role": "siroleg.bc.analis,siroleg.administrator",
				"icon": "fa-map-marker-alt",
				"to": "/statistik"
			}
		]
	},

	/**
	 * menu utk penindakan
	 */
	{
		"section": "Penindakan",
		"role": "siroleg.bc.analis,siroleg.administrator"
	},
	{
		"list": [
			{
				"role": "siroleg.bc.analis,siroleg.administrator",
				"icon": "TJ",
				"item": "Rekam Tindak Lanjut",
				"to": "/tinjut?mode=rekam_tinjut"
			},
		]
	},

	/**
	 * menu untuk pemda
	 */
	{
		"section": "Pelaksana Lapangan",
		"role": "siroleg.pemda.polpp,siroleg.administrator"
	},
	{
		"list": [
			{
				"role": "siroleg.pemda.polpp,siroleg.administrator",
				"item": "Rekam Temuan",
				"icon": "fa-file-excel",
				"to": "/temuan/new"
			},
			{
				"role": "siroleg.pemda.polpp,siroleg.administrator",
				"item": "Edit Temuan",
				"icon": "fa-pencil-alt",
				"to": "/temuan/edit"
			}
		]
	},

	/**
	 * menu untuk browse data aduan
	 */
	{
		"section": "Browse Data",
		"role": "*"
	},
	{
		"role": "*",
		"list": [
			{
				"item": "Browse",
				"icon": "fa-search",
				"children": [
					{
						// "role": "siroleg.pemda.polpp,siroleg.administrator",
						"item": "Temuan",
						"icon": "fa-shipping-fast",
						"to": "/temuan"
					},

					{
						"role": "siroleg.administrator,siroleg.bc.analis",
						"item": "Tindak Lanjut",
						"icon": "fa-stamp",
						"to": "/tinjut"
					},
					/* {
						"role": "siroleg.bc.analis,siroleg.administrator",
						"item": "Surat Bukti Penindakan",
						"icon": "SBP",
						"to": "/sbp"
					},
					{
						"role": "siroleg.bc.analis,siroleg.administrator",
						"item": "Arsip Tindak Lanjut",
						"icon": "fa-file-archive",
						"to": "/arsip"
					} */
				]
			}
		]
	},

	/**
	 * referensi data umum, semua bisa lihat
	 */
	/* {
		"section": "Referensi",
		"role": "*"
	},
	{
		"role": "*",
		"list": [
			{
				"item": "Data Referensi",
				"icon": "fa-database",
				"children": [
					{
						"item": "Toko",
						"icon": "fa-warehouse",
						"to": "/toko"
					}
				]
			}
		]
	}, */

	/**
	 * menu khusus untuk administrator
	 */
	{
		"section": "RESTRICTED",
		"role": "siroleg.administrator"
	},
	{
		"list": [
			{
				"role": "siroleg.administrator",
				"item": "Log Aktifitas",
				"icon": "fa-eye",
				"to": "/log-aktifitas"
			}
		]
	},
	{
		"section": "User Admin",
		"role": "siroleg.usermanager"
	},
	{
		"list": [
			{
				"role": "siroleg.usermanager",
				"item": "Pengelolaan User",
				"icon": "fa-users-cog",
				"to": "https://app.siroleg.xyz"
			}
		]
	}

]

// ==================== METHODS ==============================================================

/**
 * cek apakah menu item bisa diproses, menggunakan fungsi `fnCheckRole`
 * @param {Object} input menu item
 * @param {Function} fnCheckRole fungsi untuk mengecek role
 * @returns {Boolean} true klo role cek lolos, false klo ngga
 */
function canProcess (input, fnCheckRole) {
	if ('role' in input && typeof fnCheckRole !== 'undefined') {
		// role check present
		// return checkRole(input['role'])
		return fnCheckRole(input['role'])
	}
	// by default we can
	return true
}

/**
 * Proses element menu
 * @param {Array} arr array yang akan diubah isinya oleh fungsi ini
 * @param {*} input menu elemen yang akan diparse
 * @param {*} fnCheckRole fungsi untuk cek role info dari elemen
 * @returns
 */
function processElement (arr, input, fnCheckRole) {
	if (!canProcess(input, fnCheckRole)) {
		return
	}
	// gotta check what type of input it is?
	if ('section' in input) {
		// process section
		processSection(arr, input)
	} else if ('list' in input) {
		// process list tag
		processList(arr, input, fnCheckRole)
	} else if ('item' in input) {
		// process item
		processItem(arr, input, fnCheckRole)
	}
}

/**
 * Proses menu item jenis 'section'
 * @param {Array} arr array yang akan berisi parsed data dari item ini
 * @param {Object} input menu item
 */
function processSection (arr, input) {
	console.log('processing section: ', input)
	// generate a SideNavSection
	arr.push({
		type: 'SideNavSection',
		data: {
			text: input["section"]
		}
	})
}

/**
 * Proses menu item jenis 'list'
 * @param {*} arr tempat menampung parsed data
 * @param {*} input menu item list
 * @param {*} fnCheckRole fungsi untuk cek role
 */
function processList (arr, input, fnCheckRole) {
	console.log('processing list: ', input)
	// generate a SideNavList
	var ret = {
		type: 'SideNavItemList',
		data: {
			option: []
		}
	}

	// now we gotta process each child
	if (Array.isArray(input['list'])) {
		console.log('got valid item list input', input['list'])
		input['list'].forEach(e => {
			processElement(ret.data.option, e, fnCheckRole)
		})
	}

	arr.push(ret)
}

/**
 * Proses menu item tipe 'item' (link betulan)
 * @param {*} arr tempat nampung data
 * @param {*} input menu item 'item'
 * @param {*} fnCheckRole fungsi untuk cek role
 */
function processItem (arr, input, fnCheckRole) {
	console.log('processing item: ', input)

	// can we?
	if (!canProcess(input, fnCheckRole)) {
		console.log("SKIPPING ITEM: ", input)
		return
	}

	// generate a SideNavItem
	var ret = {
		type: 'SideNavItem',
		data: {
			text: input['item']
		}
	}

	// conditional processing
	if ('icon' in input) {
		ret.data.icon = input['icon']
	}

	if ('to' in input) {
		ret.data.to = input['to']
	}

	// if we have children
	if ('children' in input && Array.isArray(input['children'])) {
		// generate empty array
		ret.data.children = []

		// populate it
		input['children'].forEach(e => {
			processElement(ret.data.children, e, fnCheckRole)
		})
	}

	arr.push(ret)
}

/**
 *
 * @param {Array} arrInput array input elemen2 menu
 * @param {*} fnCheckRole fungsi untuk cek role, wajib
 * @returns
 */
function generateMenu(arrInput, fnCheckRole) {
	var menus = []
	arrInput.forEach((e) => {
		processElement(menus, e, fnCheckRole)
	})
	return menus
}


/**
 * export the structure along with something else perhaps?
 */
export {
	structure,
	generateMenu
}



// WEBPACK FOOTER //
// ./src/libs/menu.js